import { useEffect } from "react";
import { useAuthStore } from "./useAuth";

/**
 * Hook that applies the organisation theme to the document
 */
export const useTheme = () => {
  const { currentOrganisation } = useAuthStore();

  useEffect(() => {
    const theme = currentOrganisation?.theme || "default";
    document.documentElement.setAttribute("data-theme", theme);
  }, [currentOrganisation?.theme]);
};
